type AndroidAppBridge = {
  getVersion?: () => string;
};

declare global {
  interface Window {
    AndroidApp?: AndroidAppBridge;
  }
}

/** Installed APK versionName from the native JS bridge, or null outside the APK. */
export const getApkVersion = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    const version = window.AndroidApp?.getVersion?.();
    if (typeof version !== 'string') return null;
    const trimmed = version.trim();
    return trimmed.length > 0 ? trimmed : null;
  } catch {
    return null;
  }
};

const parseVersionParts = (version: string): number[] =>
  version.split('.').map((part) => {
    const n = parseInt(part, 10);
    return Number.isFinite(n) ? n : 0;
  });

export const isApkVersionAtLeast = (minimum: string): boolean => {
  const current = getApkVersion();
  if (!current) return false;
  const a = parseVersionParts(current);
  const b = parseVersionParts(minimum);
  const len = Math.max(a.length, b.length);
  for (let i = 0; i < len; i++) {
    const left = a[i] ?? 0;
    const right = b[i] ?? 0;
    if (left > right) return true;
    if (left < right) return false;
  }
  return true;
};

export const isApkOnlyBonusVisible = (bonus: {
  only_apk?: boolean;
  min_apk_version?: string | null;
}): boolean => {
  if (!bonus.only_apk) return true;
  if (!getApkVersion()) return false;

  const minApkVersion = bonus.min_apk_version?.trim();
  if (!minApkVersion) return true;
  return isApkVersionAtLeast(minApkVersion);
};
